// extracted by mini-css-extract-plugin
export var buttons = "_3q-0";
export var buttonsActive = "_3q-h";
export var cancelConfirm = "_3q-1";
export var closeButton = "_3q-2";
export var column = "_3q-3";
export var container = "_3q-4";
export var detailHeader = "_3q-6";
export var detailTitle = "_3q-7";
export var detailsContent = "_3q-5";
export var header = "_3q-8";
export var headerWithClose = "_3q-9";
export var icon = "_3q-a";
export var infoIcon = "_3q-c";
export var informationContainer = "_3q-b";
export var sideDrawer = "_3q-d";
export var sideDrawerOpen = "_3q-e";
export var stickyFooter = "_3q-f";
export var typeOption = "_3q-g";